module.exports = __webpack_public_path__ + "static/iPhone13@2x-81a4cf287b03f1641b21936236686228.png";